import { memo, useCallback } from 'react';

import { MapView as MapViewContainer } from '@studio/map';
import { MapInterface } from '@studio/map/utils';

import { useMapViewDispatch } from '@src/contexts';
import { useActiveMapStyle } from '@src/hooks';
import { customFetch } from '@src/utils/CustomFetch';

import { MapViewActions } from './MapViewActions';

interface MapViewProps {
  children?: React.ReactNode;
}

export const MapView = memo(function MapView({ children }: MapViewProps) {
  const dispatch = useMapViewDispatch();

  useActiveMapStyle();

  const handleAreaChange = useCallback(
    (area: number) => {
      dispatch({ area, hasArea: area > 0 });
    },
    [dispatch]
  );

  const handleReady = useCallback(
    (mapInstance: MapInterface) => {
      dispatch({ mapInstance });
    },
    [dispatch]
  );

  const handleDispose = useCallback(() => {
    dispatch({ mapInstance: null });
  }, [dispatch]);

  return (
    <MapViewContainer
      onAreaChange={handleAreaChange}
      onReady={handleReady}
      onDispose={handleDispose}
      enableDeleteKeys
      accessToken={import.meta.env.VITE_MAPBOX_TOKEN}
      // @ts-ignore
      fetchTile={customFetch.fetchTile}
      // tabIndex can be overridden if you handle keys on the map div
      // tabIndex={0}
    >
      {children}
      <MapViewActions />
    </MapViewContainer>
  );
});

MapView.displayName = 'MapView';
